import React, { Component } from 'react';
import AppsSectionSingle from './AppsSectionSingle';
import AppsSectionMultiple from './AppsSectionMultiple';

class AppsSection extends Component {
  render() {
    const { apps, language, t } = this.props;
    if (!apps || apps.length === 0) {
      return null;
    }
    if (apps.length === 1) {
      return <AppsSectionSingle app={apps[0]} language={language} t={t} />;
    }
    return <AppsSectionMultiple apps={apps} language={language} t={t} />;
  }
}

export default AppsSection;
